import { makeLocalMapBridge } from './__generated__/makeLocalMapBridge';
import { installLocalMapBridgeDriver } from './installLocalMapBridgeDriver';
const isLocalMapHandler = () => {
    var _a;
    const { webkit, AndroidFunction } = window;
    return (!!((_a = webkit === null || webkit === void 0 ? void 0 : webkit.messageHandlers) === null || _a === void 0 ? void 0 : _a.localMapHandler) ||
        !!(AndroidFunction === null || AndroidFunction === void 0 ? void 0 : AndroidFunction.localMapHandler));
};
export { isLocalMapHandler, makeLocalMapBridge, installLocalMapBridgeDriver };
